import { Inter } from "@next/font/google";
import localFont from "@next/font/local";
import clsx from "clsx";

// NOTE: this font loading strategy does not work in projects that use a custom Babel configuration (eg. User app)
// @next/font uses SWC to work, but usage of custom babel configuation overrides that and stops it from working.
// TODO: safely remove Babel from User app so we can use this (and because SWC is newer and better)

export const FontInter = Inter({
  subsets: ["latin"],
  display: "swap",
  variable: "--font-inter",
});

export const FontVastagoGrotesk = localFont({
  src: "./vastago-grotesk.woff2",
  display: "swap",
  variable: "--font-vastago-grotesk",
});

export const appFontsClassName = clsx(
  FontInter.variable,
  FontVastagoGrotesk.variable
);
